<template>
  <v-container class="pa-0 ma-0 d-flex flex-column align-center cart-page">
    <!-- Header -->
    <v-container class="pa-3 ma-0 product-header">
      <v-card-text class="pa-0 ma-0 header-title">{{ $t("cart") }}</v-card-text>
      <v-icon class="back-icon" @click="$emit('close')"> mdi-chevron-left </v-icon>
    </v-container>
    <!-- Content -->
    <v-container class="cart-list pa-0 ma-0">
      <!-- there is product -->
      <template v-if="cartItems.length">
        <v-container
          v-for="(item, j) in cartItems"
          :key="item.id"
          class="pa-5 cart-item d-flex align-center justify-space-between mb-2"
        >
          <!--  product img -->
          <v-container class="pa-0 ma-0 image-wrapper" style="width: auto;">
            <img :src="item.image" alt="" class="item-image" />
            <v-card-text class="pa-0 ma-0 text-body-2 item-number-right"
              >{{ j + 1 }}.</v-card-text
            >
          </v-container>
          <!-- product deetails -->
          <v-container
            class="pa-0 ma-0 item-info d-flex flex-column flex-grow-1 ml-2 mr-2"
          >
            <v-card-text class="pa-0 ma-0 item-title">{{ item.name }}</v-card-text>
            <v-card-text class="pa-0 ma-0 item-price"
              >{{ $numberFormat(itemTotals[j])
              }}{{ $store.state.currency.name }}</v-card-text
            >
          </v-container>

          <!--   add product btn  -->
          <v-sheet class="item-counter d-flex align-center">
            <v-btn
              outlined
              color="primary"
              class="counter-btn"
              @click="increaseCount(item)"
              height="18"
              width="18"
              style="min-width: auto"
            >
              <v-icon size="15">mdi-plus</v-icon>
            </v-btn>

            <v-card-text class="count">{{ item.count }}</v-card-text>

            <v-btn
              outlined
              color="primary"
              class="counter-btn"
              @click="decreaseCount(item)"
              height="18"
              width="18"
              style="min-width: auto"
            >
              <v-icon size="15">mdi-minus</v-icon>
            </v-btn>
          </v-sheet>
        </v-container>
      </template>

      <!-- is empty-->
      <template v-else>
        <div
          class="empty-cart d-flex flex-column align-center justify-center text-center"
        >
          <v-card-text class="pa-0 ma-0 empty-title">{{
            $t("cart is empty")
          }}</v-card-text>
          <v-btn color="primary" rounded class="empty-btn mt-4" @click="$emit('close')">
            {{ $t("choose product") }}
          </v-btn>
        </div>
      </template>
    </v-container>

    <!--  footer -->
    <v-container class="payment-footer d-flex align-center justify-space-between">
      <v-container class="pa-0 ma-0 footer-left d-flex align-center">
        <div class="footer-left d-flex align-center">
          <v-card-text class="footer-total pa-0 ma-0 ml-2">
            {{ $numberFormat(totalPrice) }} {{ $store.state.currency.name }}
          </v-card-text>
        </div>
      </v-container>

      <v-btn
        tonal
        :disabled="cartItems.length === 0"
        color="#00664D"
        class="footer-button pa-3 px-6 py-3"
        @click="$emit('go-checkout')"
      >
        {{ $t("continue peyment") }}
      </v-btn>
    </v-container>
  </v-container>
</template>

<script>
import Mixin from '@/Mixins/mixin'
export default {
  name: 'CartPage',
  mixins: [Mixin],
  props: {
    cartItems: {
      type: Array,
      required: true
    },
    totalPrice: {
      type: Number,
      required: true
    }
  },
  computed: {
    itemTotals () {
      const productTotal = []
      for (const item of this.cartItems) {
        const price = Number(String(item.price).replace(/,/g, '')) || 0
        const totalPerProduct = price * item.count
        productTotal.push(totalPerProduct)
      }
      this.$emit('itemTotals', productTotal)
      console.log(productTotal)
      return productTotal
    }
  },
  methods: {
    increaseCount (item) {
      this.$emit('add', item)
    },
    decreaseCount (item) {
      this.$emit('remove', item)
    }
  }
}
</script>

<style scoped>
.cart-page {
  background-color: #fff;
  height: 100vh;
  direction: rtl;
}
.product-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  height: 60px;
}
.header-title {
  font-weight: 700;
  font-size: 18px;
  color: #1a1a1a;
}
.back-icon {
  font-size: 26px;
  cursor: pointer;
  color: #1a1a1a;
}
.image-wrapper {
  position: relative;
  display: inline-block;
}
.item-number-right {
  position: absolute;
  top: 4px;
  right: -13px;
}
.item-image {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #d9d9d9;
}
.item-title {
  font-weight: 600;
  font-size: 14px;
  color: #1a1a1a;
}
.item-price {
  font-size: 13px;
  color: #555;
}
.item-counter {
  min-width: 90px;
  justify-content: center;
  gap: 6px;
}
.count {
  font-size: 12px;
  font-weight: 500;
  color: #333;
  background-color: #d9d9d9;
  padding: 2px 14px;
  border-radius: 6px;
}
.empty-cart {
  width: 100%;
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.empty-title {
  font-weight: 600;
  font-size: 15px;
  color: #1a1a1a;
}
.empty-btn {
  font-weight: 600;
  font-size: 14px;
}
.payment-footer {
  background-color: #fff;
  border-top: 1px solid #eee;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.05);
  padding: 16px;
  margin-top: auto;
}
.footer-label {
  font-weight: 600;
  font-size: 15px;
  color: #1a1a1a;
}
.footer-total {
  margin-right: 6px;
  font-weight: 700;
  color: #1a1a1a;
}
.footer-button {
  font-weight: 600;
  font-size: 14px;
}
</style>
